import { cn } from "@/lib/helpers/cn";

import { ACP_COLUMN_LABELS, ACP_DESKTOP_GRID_CLASSES } from "./SectionDetailList";

// Renders the column labels once above the consent-version list — rows only render values, not
// labels, at this breakpoint. Below lg2 each row still shows its own label above its value, so
// this stays hidden there.
export function SectionDetailListHeader() {
  return (
    <div className={cn("tw:hidden tw:lg2:grid", ACP_DESKTOP_GRID_CLASSES)}>
      {ACP_COLUMN_LABELS.map((label, index) => (
        <b className="tw:text-test-primary tw:text-sm tw:font-bold" key={label || index}>
          {label}
        </b>
      ))}
    </div>
  );
}
